import * as React from 'react';
import { connect } from 'react-redux';
import { TextField } from '@ane/ui-components/lib/components/TextField';
import { Selection, SelectionMode } from '@ane/ui-components/lib/Utilities';
import { PlaceHolder, AriaLabel } from '../../../../../models/ComputeAbstract';
import { validateMinMaxWorkers } from '../../utils/ComputeFormikSettingsUtils';
import { StepContainer } from '@ane/ui-components/lib/components/StepContainer';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import { DropdownField } from '@ane/ui-components/lib/components/FormikFormFields/DropdownField';
import { ChoiceGroupField } from '@ane/ui-components/lib/components/FormikFormFields/ChoiceGroupField';
import { GetSubClisterListWhenAddChild, SubClusterList } from '../SubClusterList/SubClusterList';
import { SubClusterListV2 } from '../SubClusterList/SubClusterListV2';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
export const getSynapseValidateMessage = (name, value) => {
    if (!value || '' === value.toString().trim()) {
        return 'Required';
    }
    switch (name.toLowerCase()) {
        case 'fixedworkers':
        case 'minworkers':
        case 'maxworkers':
        case 'maxconcurrency':
            if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
                return 'Please enter an integer greater than 0';
            }
            else {
                return '';
            }
        case 'cluster':
            if (!/^cosmos[0-9]{2}$/.test(value)) {
                return 'The field cluster must match the placeholder expression. e.g. cosmos09';
            }
            else {
                return '';
            }
        case 'name':
            if (!/^[a-zA-Z0-9-_]{1,128}$/.test(value)) {
                return 'Name is invalid. Only alphanumeric characters, hyphens, and underscores are allowed.';
            }
            else {
                return '';
            }
        case 'developmenturl':
            try {
                new URL(value);
            }
            catch (_) {
                return 'Require url';
            }
            return '';
        default:
            return '';
    }
};
const mapStateToProps = (state, props) => {
    return {
    //workspaceId: state.currentUserDetails.userAffinity?.data?.workspaceId || ''
    };
};
export var ClusterScale;
(function (ClusterScale) {
    ClusterScale["Fixed"] = "Fixed";
    ClusterScale["AutoScaling"] = "AutoScaling";
})(ClusterScale || (ClusterScale = {}));
export const DefaultNodeSize = 'Default';
export class SynapseSubClusterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.onAddChild = () => {
            let defaultChild = {
                Name: '',
                DevelopmentUrl: '',
                StorageAccount: '',
                StorageContainer: '',
                PoolName: '',
                MaxConcurrency: '',
                NodeSize: 'Small',
                ScaleType: 'Fixed',
                FixedWorkers: '',
                MinWorkers: '',
                MaxWorkers: '',
                SparkVersion: 'Spark 2.4',
                required: {
                    Name: '',
                    DevelopmentUrl: '',
                    StorageAccount: '',
                    StorageContainer: '',
                    PoolName: '',
                    MaxConcurrency: '',
                    ScaleType: '',
                    FixedWorkers: '',
                    MinWorkers: '',
                    MaxWorkers: '',
                    SparkVersion: '',
                },
            };
            let subClusterList = GetSubClisterListWhenAddChild(this.props.subClusterList, defaultChild);
            this.props.setFieldValue && this.props.setFieldValue('synapseSubClusterList', subClusterList, true);
        };
        this._onRenderRow = (props) => {
            if (!props) {
                return null;
            }
            const listIndex = props.itemIndex;
            return (React.createElement("div", { style: { paddingLeft: !EnvironmentService.enableSubClusterA11yUpdate() ? '85px' : undefined }, role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'row' : undefined },
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(TextField, { label: AriaLabel.SubClusterName, required: true, ariaLabel: AriaLabel.SubClusterName, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.SubClusterName, value: `${this.props.subClusterList && this.props.subClusterList[listIndex].Name}`, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]['required'].Name : '')}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'Name');
                        } })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(TextField, { label: AriaLabel.DevelopmentUrl, required: true, ariaLabel: AriaLabel.DevelopmentUrl, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.DevelopmentUrl, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['DevelopmentUrl']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'DevelopmentUrl');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]['required'].DevelopmentUrl : '')}` })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(TextField, { label: AriaLabel.StorageAccount, required: true, ariaLabel: AriaLabel.StorageAccount, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.StorageAccount, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['StorageAccount']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'StorageAccount');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]['required'].StorageAccount : '')}` })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(TextField, { label: AriaLabel.StorageContainer, required: true, ariaLabel: AriaLabel.StorageContainer, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.StorageContainer, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['StorageContainer']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'StorageContainer');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]['required'].StorageContainer : '')}` })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(TextField, { label: AriaLabel.PoolName, required: true, ariaLabel: AriaLabel.PoolName, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.PoolName, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['PoolName']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'PoolName');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]['required'].PoolName : '')}` })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(TextField, { label: AriaLabel.ClusterMaxConcurrentJobs, required: true, ariaLabel: AriaLabel.ClusterMaxConcurrentJobs, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.ClusterMaxConcurrentJobs, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['MaxConcurrency']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'MaxConcurrency');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]['required'].MaxConcurrency : '')}` })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(DropdownField, { name: 'nodeSize', label: AriaLabel.NodeSize, required: true, isReadOnly: !!this.props.isReadOnly, placeholder: PlaceHolder.NodeSize, ariaLabel: AriaLabel.NodeSize, options: this.onExecutorSizeOption(), labelProps: {
                            iconProps: {
                                calloutProps: {
                                    content: 'We have reserved some memory for our driver, so the memory size might be different from your setting in Synapse Studio.',
                                },
                            },
                        }, defaultSelectedKey: this.props.subClusterList ? this.props.subClusterList[listIndex].NodeSize : '', errorMessage: this.getTextErrorMessage(listIndex, 'NodeSize'), onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue ? newValue.key.toString() : '', 'NodeSize');
                        } })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(DropdownField, { name: 'sparkVersion', label: AriaLabel.ClusterRuntimeVersion, isReadOnly: !!this.props.isReadOnly, placeholder: PlaceHolder.ClusterRuntimeVersion, ariaLabel: AriaLabel.ClusterRuntimeVersion, options: this.onClusterVersionOption(), required: true, defaultSelectedKey: this.props.subClusterList ? this.props.subClusterList[listIndex].SparkVersion : '', errorMessage: this.getTextErrorMessage(listIndex, 'SparkVersion'), onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue ? newValue.text : '', 'SparkVersion');
                        } })),
                React.createElement("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? 'cell' : undefined },
                    React.createElement(ChoiceGroupField, { name: 'scaleType', label: AriaLabel.ClusterScale, ariaLabel: AriaLabel.ClusterScale, isReadOnly: !!this.props.isReadOnly, defaultSelectedKey: `${this.props.subClusterList &&
                            (this.props.subClusterList[listIndex].ScaleType === ClusterScale.AutoScaling
                                ? ClusterScale.AutoScaling
                                : ClusterScale.Fixed)}`, options: [
                            { key: ClusterScale.Fixed, text: 'Fixed (default)', ariaLabel: 'ClusterScaleFixed' },
                            { key: ClusterScale.AutoScaling, text: 'Autoscaling', ariaLabel: 'ClusterScaleAutoscaling' },
                        ], required: true, onChange: (ev, option) => {
                            this._handleChange(listIndex, option === null || option === void 0 ? void 0 : option.key, 'ScaleType');
                        } }),
                    this._getClusterScaleUI(listIndex))));
        };
        this._handleChange = (index, newValue, columnName) => {
            let subClusterList = [...this.props.subClusterList];
            let subCluster = subClusterList[index];
            if (columnName === 'ScaleType') {
                if (newValue === ClusterScale.AutoScaling) {
                    subClusterList[index].required.FixedWorkers = '';
                    subClusterList[index].required.MinWorkers = getSynapseValidateMessage('MinWorkers', subCluster.MinWorkers);
                    subClusterList[index].required.MaxWorkers = getSynapseValidateMessage('MaxWorkers', subCluster.MaxWorkers);
                }
                else {
                    subClusterList[index].required.MinWorkers = '';
                    subClusterList[index].required.MaxWorkers = '';
                    subClusterList[index].required.FixedWorkers = getSynapseValidateMessage('FixedWorkers', subCluster.FixedWorkers);
                }
            }
            let columnNewValue = '';
            let validationMessage = '';
            if (null != newValue && '' !== newValue.toString().trim()) {
                columnNewValue = newValue;
                validationMessage = this._updateValidateMessage(columnName, newValue, subCluster);
            }
            else {
                columnNewValue = '';
                validationMessage = 'Required';
            }
            subClusterList = [
                ...this.props.subClusterList.slice(0, index),
                Object.assign(Object.assign({}, subCluster), { [columnName]: columnNewValue, required: Object.assign(Object.assign({}, subCluster.required), { [columnName]: validationMessage }) }),
                ...this.props.subClusterList.slice(index + 1),
            ];
            this.props.setFieldValue && this.props.setFieldValue('synapseSubClusterList', subClusterList, true);
        };
        this._getClusterScaleUI = (listIndex) => {
            let subClusterList = [...this.props.subClusterList];
            let clusterScale = subClusterList[listIndex].ScaleType;
            if (clusterScale && clusterScale === ClusterScale.AutoScaling) {
                return (React.createElement("div", null,
                    React.createElement(TextField, { label: AriaLabel.MinimumWorkersPerTask, required: true, ariaLabel: AriaLabel.MinimumWorkersPerTask, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.MinimumWorkersPerTask, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['MinWorkers']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'MinWorkers');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0
                                ? this.props.subClusterList[listIndex]['required'].MinWorkers
                                    ? this.props.subClusterList[listIndex]['required'].MinWorkers
                                    : ''
                                : '')}` }),
                    React.createElement(TextField, { label: AriaLabel.MaximumWorkersPerTask, required: true, ariaLabel: AriaLabel.MaximumWorkersPerTask, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.MaximumWorkersPerTask, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['MaxWorkers']}`, onChange: (index, newValue) => {
                            this._handleChange(listIndex, newValue, 'MaxWorkers');
                        }, errorMessage: `${this.props.subClusterList &&
                            (this.props.subClusterList.length > 0
                                ? this.props.subClusterList[listIndex]['required'].MaxWorkers
                                    ? this.props.subClusterList[listIndex]['required'].MaxWorkers
                                    : ''
                                : '')}` })));
            }
            return (React.createElement(TextField, { label: AriaLabel.NumberOfWorkersPerTask, required: true, ariaLabel: AriaLabel.NumberOfWorkersPerTask, isReadOnly: !!this.props.isReadOnly, description: PlaceHolder.NumberOfWorkersPerTask, value: `${this.props.subClusterList && this.props.subClusterList[listIndex]['FixedWorkers']}`, onChange: (index, newValue) => {
                    this._handleChange(listIndex, newValue, 'FixedWorkers');
                }, errorMessage: `${this.props.subClusterList &&
                    (this.props.subClusterList.length > 0
                        ? this.props.subClusterList[listIndex]['required'].FixedWorkers
                            ? this.props.subClusterList[listIndex]['required'].FixedWorkers
                            : ''
                        : '')}` }));
        };
        this.onClusterVersionOption = () => {
            const items = [
                { key: 'Spark 2.4', text: 'Spark 2.4' },
                { key: 'Spark 3.1', text: 'Spark 3.1' },
                { key: 'Spark 3.2', text: 'Spark 3.2' },
                { key: 'Spark 3.3', text: 'Spark 3.3' },
                { key: 'Spark 3.4', text: 'Spark 3.4' },
            ];
            return items;
        };
        this.onExecutorSizeOption = () => {
            //https://experimentation.visualstudio.com/Analysis%20and%20Experimentation/_git/AnE.ExP.Pipeline.ComputeManagementService/pullrequest/89742?path=%2Fsrc%2FComputeManagementService.WebApi%2FValidators%2FSynapsePoolValidator.cs&_a=files
            const items = [
                { key: 'Small', text: 'Small, 4 vCores, 28GB memory' },
                { key: 'Medium', text: 'Medium, 8 vCores, 56GB memory' },
                { key: 'Large', text: 'Large, 16 vCores, 112GB memory' },
                { key: 'XLarge', text: 'XLarge, 32 vCores, 224GB memory' },
                { key: 'XXLarge', text: 'XXLarge, 64 vCores, 400GB memory' },
            ];
            return items;
        };
        this.getTextErrorMessage = (listIndex, key) => {
            return (this.props.subClusterList &&
                (this.props.subClusterList.length > 0
                    ? this.props.subClusterList[listIndex]['required'][key]
                        ? this.props.subClusterList[listIndex]['required'][key]
                        : ''
                    : ''));
        };
        this._selection = new Selection({
            onSelectionChanged: () => { },
            selectionMode: SelectionMode.multiple,
            getKey: (item) => item.key,
        });
    }
    componentDidMount() {
        var _a;
        if (!!!this.props.isUpdateCompute && ((_a = this.props.subClusterList) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            this.onAddChild();
        }
    }
    render() {
        var _a, _b;
        return (React.createElement(StepContainer, { className: "create-datalocation-info-tab" },
            !this.props.isUpdateCompute && (React.createElement(FormHeading, { pageTitle: "Sub-cluster Configuration" },
                "This is where you enter information about all your sub-cluster configurations. You may add one or more.",
                React.createElement("a", { href: "/compute" }, "Learn more"))),
            React.createElement(FormSection, null, EnvironmentService.enableSubClusterA11yUpdate() ? (React.createElement(SubClusterListV2, { subClusterList: (_a = this.props.subClusterList) !== null && _a !== void 0 ? _a : [], onRenderSubCluster: this._onRenderRow, onAddSubCluster: this.onAddChild, onDeleteSubCluster: (index) => {
                    let subClusterList = [...this.props.subClusterList];
                    subClusterList = subClusterList.filter((item, key) => key !== index);
                    this.props.setFieldValue && this.props.setFieldValue('synapseSubClusterList', subClusterList, true);
                }, isReadOnly: !!this.props.isReadOnly })) : (React.createElement(SubClusterList, { isUpdateCompute: this.props.isUpdateCompute, subClusterList: (_b = this.props.subClusterList) !== null && _b !== void 0 ? _b : [], selection: this._selection, onRenderSubCluster: this._onRenderRow, onAddSubCluster: this.onAddChild, onDeleteSubCluster: () => {
                    let subClusterList = [...this.props.subClusterList];
                    subClusterList = subClusterList.filter((item, key) => !!!this._selection.isIndexSelected(key));
                    this.props.setFieldValue && this.props.setFieldValue('synapseSubClusterList', subClusterList, true);
                }, isReadOnly: !!this.props.isReadOnly })))));
    }
    _updateValidateMessage(name, value, subCluster) {
        let required = '';
        if (value === undefined || '' === value.toString().trim()) {
            return 'Required';
        }
        else {
            required = getSynapseValidateMessage(name, value);
        }
        if ('' === required && (name === 'MinWorkers' || name === 'MaxWorkers')) {
            const minWorkers = name === 'MinWorkers' ? value : subCluster.MinWorkers === '' ? '1' : subCluster.MinWorkers;
            const maxWorkers = name === 'MaxWorkers' ? value : subCluster.MaxWorkers === '' ? Number.MAX_SAFE_INTEGER.toString() : subCluster.MaxWorkers;
            required = validateMinMaxWorkers(minWorkers, maxWorkers);
            subCluster.required.MinWorkers = required;
            subCluster.required.MaxWorkers = required;
        }
        return required;
    }
}
export default connect(mapStateToProps)(SynapseSubClusterComponent);

//# sourceMappingURL=SynapseSubClusterComponent.js.map
